/* eslint no-unused-vars: off */
// External library
import Swiper from 'swiper/bundle'

// Component
export default () => {
    const swiperAwards = new Swiper('.awards-grid-swiper', {
        keyboard: {
            enabled: true
        },
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
        speed: 1000,
        breakpoints: {
            600: {
                slidesPerView: 3,
                slidesPerGroup: 3
            },
            1100: {
                slidesPerView: 5,
                slidesPerGroup: 5
            },
            1280: {
                slidesPerView: 6,
                slidesPerGroup: 6
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    })

    const swiperCards = new Swiper(
        '[data-product-cards], [data-event-cards]', {
            keyboard: {
                enabled: true
            },
            slidesPerView: 'auto',
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        })

    let swiperSliders = new Swiper('[data-slider-cards]', {
        keyboard: {
            enabled: true
        },
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        autoplay: {
            pauseOnMouseEnter: true,
            disableOnInteraction: false
        }
    })

    if (!Array.isArray(swiperSliders))
        swiperSliders = [swiperSliders]

    swiperSliders
        .forEach((swiper) => swiper
            .on('slideChange', (swipe) => swipe.slides
                .forEach((s, i) => s
                    .setAttribute('aria-hidden', i !== swipe.activeIndex))))
}
